import { render, staticRenderFns } from "./Mods.vue?vue&type=template&id=507e0276&"
import script from "./Mods.vue?vue&type=script&lang=js&"
export * from "./Mods.vue?vue&type=script&lang=js&"
import style0 from "./Mods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports